// @flow
export const HIDE_MOBILE_MENU = 'hive/menu/HIDE_MOBILE_MENU';
export const TOGGLE_MOBILE_MENU = 'hive/menu/TOGGLE_MOBILE_MENU';



// WEBPACK FOOTER //
// ./src/core/state/menu/constants.js